const $ = require('cash-dom');

const Faq = {
  init() {
    $('.comparison-page .single-qa').addClass('active');

    $(document).on('mousedown', '#faq .question', function (e) {
      e.preventDefault();
      let $this = $(this).parent('.single-qa');

      $this.toggleClass('active');
    });
  },
};

module.exports = Faq;
